import {
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase"; // Importera din Firestore-konfiguration
import { getTenantIdFromHost } from "./Tenant/getTenantId";

export const saveResponse = async (responseData) => {
  const tenantId = getTenantIdFromHost();

  // 1) spara svaret
  const payload = {
    ...responseData,
    timestamp: serverTimestamp(),
  };

  const resRef = await addDoc(
    collection(db, "tenants", tenantId, "responses"),
    payload,
  );

    return resRef.id; // så du kan await:a och ev logga
};
